import FormLabel from './formLabel';

const colorMappings = {
    primary: "blue",
    secondary: "zinc",
    danger: "red",
    success: "green",
}
const TwInputText = ({ value, type, label, onChange, onClick, onKeyDown, size, placeholder, inputProps, direction, width }) => {
    const cssClass = [
        // "mb-4"
    ]
    const cssClasses = [
        "shadow",
        "appearance-none",
        "border",
        "rounded",
        "w-full",
        "py-1",
        "px-2",
        "text-gray-700",
        "dark:text-gray-300",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "bg-transparent",
    ]
    if (direction == "ltr") {
        cssClasses.push("ltr")
    }
    else {
        cssClasses.push("rtl")
    }
    return <div className={cssClass.join(" ")}>
        {label && <FormLabel>{label}</FormLabel>}
        <input
            className={cssClasses.join(" ")}
            type={type || "text"}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onClick={onClick}
            onKeyDown={onKeyDown}
            {...inputProps}
            style={{ width: width }}
        />
    </div>;
};

export default TwInputText;
